import React from 'react';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { OpportunitiesList } from '../components';

export const OpportunitiesListPage = () => {
  return (
    <PageContainer title="Opportunities">
      <CardContainer>
        <OpportunitiesList />
      </CardContainer>
    </PageContainer>
  );
};
